import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingPartnerActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Partner/PartnerBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingPartner"
				RenderedComponent={this.RenderedComponent}
				context="AccountingPartner"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingPartnerActivity)
